import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';
import { Observable } from 'rxjs/Observable';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import * as moment from 'moment';

import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { Util } from './../../../utils/util';
import { EventTypes } from './../../../shared/EventTypes';

import { ListItem } from '../../../shared/list-confirmation/model/list-item';
import { PaymentFederalTaxes } from './../models/payment-federal-taxes';
import { CodePay } from './../models/code-pay';

import { PaymentFederalTaxesEventType } from './../payment-federal-taxes.event.type';
import { PaymentFederalTaxesService } from './../payment-federal-taxes.service';
import { LimitsService } from '../../limits/limits.service';
import { ModalErrorEventType } from '../../../shared/modal-error/modal-error.event.type';

@Component({
	selector: 'app-payment-gps',
	templateUrl: './payment-gps.component.html',
	styleUrls: ['./payment-gps.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PaymentGpsComponent implements OnInit, OnDestroy {

	@Input() showBalance;
	@Output() showBalanceChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	imagesTax: Array<string> = [
		'assets/imgs/dashboard/logo-inss.png'
	];
	descriptionTax: String = `Ministério da Previdência e Assistência Social - MPAS <br>
	Instituto Nacional do Seguro Social - INSS <br>
	GPS (Guia da Previdência Social)`;

	info1: String = `Para o Código da Receita <strong>0089</strong> o Número de Referência é de
	preenchimento obrigatório. <a href="#">Consulte aqui</a> a relação dos códigos
	de Receita que obrigam a digitação do “Número de Referência”.`;

	info2: String = `Encontre mais informações para o cálculo de cotas do IRPF no
	site da Receita Federal através do endereço: <br>
	<a href="http://www.receita.fazenda.gov.br" target="_blank">www.receita.fazenda.gov.br</a>`;

	// filteredOptions: Observable<any[]>;

	typesIdentifiers = [
		{code: 1, name: 'CNPJ'},
		{code: 2, name: 'Cadastro Específico do INSS - CEI'},
		{code: 3, name: 'Identificador para Débito Cadastrado - DEBCAD'},
		{code: 4, name: 'Número de Identificação do Trabalhador - NIT/PIS/PASEP'},
		{code: 8, name: 'CPF'}
	];

	@Input() paymentData: PaymentFederalTaxes;

	public form: FormGroup;
	private view = '[data-component="payment-gps"]';
	private today: number = Date.now();
	private viewHeight = 0;

	active = false;
	hasSubimited = false;
	paymentCodes: Array<CodePay> = [];
	filteredPaymentCodes: Observable<CodePay[]>;
	indetifierCpf = false;
	indetifierCnpj = false;
	isModal = true;
	@Input() maxLengthIdentifier = 240;

	cpfcnpj;
	cpfcnpjOld;

	// Calcular o total
	total;
	valueCharges;
	valueOthers;
	valueINSS;
	numberMask = createNumberMask({
		prefix: '',
		suffix: '',
		decimalSymbol: ',',
		thousandsSeparatorSymbol: '.',
		allowDecimal: true,
		allowLeadingZeroes: true,
		requireDecimal: 2
	});
	updateTotal() {
		this.valueINSS = this.valueINSS ? this.valueINSS : 0.00;
		this.valueOthers = this.valueOthers ? this.valueOthers : 0.00;
		this.valueCharges = this.valueCharges ? this.valueCharges : 0.00;

		this.total = (this.valueINSS + this.valueOthers + this.valueCharges).toFixed(2);
		this.total = this.replaceAt(this.total.toString(), this.total.length - 3, ',');
	}
	replaceAt(element, index, replacement) {
		return element.substr(0, index) + replacement + element.substr(index + replacement.length);
	}

	constructor(
		private formBuilder: FormBuilder,
		private paymentService: PaymentFederalTaxesService,
		private limitsService: LimitsService
	) {
		this.form = formBuilder.group({
			taxpayerName: [null, Validators.required],
			codePay: [null, Validators.required],
			competence: [null, Validators.required],
			typeIdentifier: [null, Validators.required],
			identifier: [null, Validators.required],
			valueINSS: [null, Validators.required],
			valueOthers: [null],
			valueCharges: [null],
			valueCollection: [null]
		});
	}

	ngOnInit() {
		AppEventDispatcher.listen( PaymentFederalTaxesEventType.STEPS_GPS.PAYMENT_GPS, () => {
			this.active = true;
			this.getCodePay(); // <-- show()
		});
	}

	updateHeight() {
		const interval = setInterval(() => {

			const containerHeight = this.getStepHeight();
			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
			clearInterval(interval);

		}, 10);
	}

	verifyZeroInss() {
		if ($('.currency-field-inss').val() === '0,00') {
			$('.currency-field-inss').val('');
		}
	}

	verifyZeroOthers() {
		if ($('.currency-field-others').val() === '0,00') {
			$('.currency-field-others').val('');
		}
	}

	verifyZeroAtt() {
		if ($('.currency-field-att').val() === '0,00') {
			$('.currency-field-att').val('');
		}
	}

	getCodePay() {
		this.preload(true);

		this.paymentService.getCodePay(this.paymentData.typeTax).subscribe( data => {

			this.paymentCodes = data;
			this.filteredPaymentCodes = this.form.controls.codePay.valueChanges.pipe(
				startWith({} as CodePay),
				map(codePay => codePay && typeof codePay === 'object' ? codePay.label : codePay),
				map(label => label ? this.filter(label) : this.paymentCodes.slice())
			);
			this.preload(false);
			this.show();

		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	setSendListener() {
		AppEventDispatcher.listen( PaymentFederalTaxesEventType.PAYMENT_FEDERAL_TAXES_SEND, () => {
			this.send();
		});
	}

	ngOnDestroy() {
		this.removeListeners();
	}

	removeListeners() {
		AppEventDispatcher.removeListener( PaymentFederalTaxesEventType.PAYMENT_FEDERAL_TAXES_SEND );
		AppEventDispatcher.removeListener( PaymentFederalTaxesEventType.STEPS_GPS.PAYMENT_GPS );
	}

	show() {
		const interval = setInterval(() => {

			if ($(this.view).length > 0) {
				const containerHeight = this.getStepHeight();

				this.viewHeight = containerHeight + 168;

				TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
				TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
				TweenMax.to('.buttons', .8, {delay: .8, bottom: 0, ease: Quint.easeOut});

				$(this.view).find('input').on('keyup focusout', () => {
					this.updateHeight();
				});

				this.setSendListener();

				clearInterval(interval);
			}
			this.showBalanceChange.emit(true);
		}, 10);
		$('.currency-field-inss').val('');
		$('.currency-field-att').val('');
		$('.currency-field-others').val('');
		$('.total-field').val('0,00');
	}

	hide() {
		this.removeListeners();

		TweenMax.to(this.view, .8, { delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.active = false;
			AppEventDispatcher.dispatch( PaymentFederalTaxesEventType.STEPS_GPS.CONFIRM_GPS, { show: true });
		}});
	}

	setIdentifierType(e) {
		const itemSelected = e.target.innerText;

		if (itemSelected === 'CPF') {
			this.indetifierCpf = true;
			this.indetifierCnpj = false;
			this.maxLengthIdentifier = 14;
			this.cpfcnpj = '';
		} else if (itemSelected === 'CNPJ') {
			this.indetifierCpf = false;
			this.indetifierCnpj = true;
			this.maxLengthIdentifier = 18;
			this.cpfcnpj = '';
		} else {
			this.indetifierCpf = false;
			this.indetifierCnpj = false;
			this.maxLengthIdentifier = 240;
			this.cpfcnpj = '';
		}
	}

	cpfcnpjKeydown(event: KeyboardEvent) {
		Util.handleCpfCnpjKeydown(event);
	}

	setIdentifierMask(event) {
		if (this.indetifierCpf || this.indetifierCnpj) {
			if (event.keyCode === 8) {
			} else if (event.target.value.length <= 19) {
				const raw = Util.removeMaskCharacters(event.target.value);
				const newVal = Util.maskCpfCnpj(raw);
				this.cpfcnpjOld = this.cpfcnpj = newVal;
			} else {
				this.cpfcnpj = this.cpfcnpjOld;
			}
		}
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	readySendGps() {
		this.hasSubimited = false;
		this.paymentData.codePayObject = this.form.controls.codePay.value;
		this.paymentData.competenceMonth = moment(this.form.controls.competence.value).month() + 1;
		this.paymentData.competenceYear = moment(this.form.controls.competence.value).year();
		this.paymentData.identifierType = this.form.controls.typeIdentifier.value;
		this.paymentData.identifier = Util.removeMaskCharacters(this.form.controls.identifier.value);
		this.paymentData.taxpayerName = this.form.controls.taxpayerName.value || '';
		this.paymentData.valueINSS = this.form.controls.valueINSS.value;
		this.paymentData.valueOthers = this.form.controls.valueOthers.value;
		this.paymentData.valueCharges = this.form.controls.valueCharges.value;
		this.paymentData.valueCollection = this.form.controls.valueCollection.value;

		this.hide();

		this.updateHeight();
	}

	send() {
		this.hasSubimited = true;

		if (this.form.valid) {
			this.readySendGps();
		}

		this.updateHeight();
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="payment-federal-taxes"] .content', show: active, delay: delay});
	}

	filter(val): CodePay[] {
		return this.paymentCodes.filter(payCode => payCode.label.includes(val));
	}
	autoCompleteDisplay(codePay: CodePay): any {
		return codePay ? codePay.label : codePay;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/payment-federal-taxes/payment-gps/payment-gps.component.ts